import React, { useEffect, useState, useRef } from "react";
import "../styles/esproPay.css";
import axios from 'axios';

const EsproPay = () => {

  const [url, setUrl] = useState("");
  const [uniquename, setUniqueName] = useState("");
  const [hashid, setHashId] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = { url,uniquename,hashid };

  axios.post('/api/coin', data)
    .then(res => {
      console.log(res);
      console.log(res.data);
    })
    .catch(error => {
      console.log(error);
    });

  event.target.reset();

    // console.log({url,uniquename,hashid});
  }

//   const axios = require('axios');
// let response = null;
// new Promise(async (resolve, reject) => {
//   try {
//     response = await axios.get('https://sandbox-api.coinmarketcap.com/v1/cryptocurrency/listings/latest', {
//       headers: {
//         'X-CMC_PRO_API_KEY': '1f0d8700-17b1-46ce-bf6d-763f7d3e54f9',
//       },
//     });
//   } catch(ex) {
//     response = null;
//     // error
//     console.log('error',ex);
//     reject(ex);
//   }
//   if (response) {
//     // success
//     const json = response.data;
//     console.log(json);
//     resolve(json);
//   }
// });



    return (
        <>
          <div className="container-fluid">
    <h2 className="text-center">ESPRO Order</h2>

    <form className="bordered" onSubmit={handleSubmit}>
        <div className="row justify-content-center">
            <div className="col-8  border p-5 ">
         
                  {/* <!-- Text input --> */}
        <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form6Example3">URL of the business premium/services that you want to purchase.</label>
          <input type="text" id="form6Example3" className="form-control" value={url}
          onChange={(e) => setUrl(e.target.value)} />
        </div>

        <div className="row mb-4">
          <div className="col">
            <div className="form-outline">
                <label className="form-label" htmlFor="form6Example1">Business/User Unique name</label>
              <input type="text" id="form6Example1" className="form-control" value={uniquename}
          onChange={(e) => setUniqueName(e.target.value)} />
            </div>
          </div>
          <div className="col">
            <div className="form-outline">
                <label className="form-label" htmlFor="form6Example2">ESPRO Amount </label>
              <input type="text" id="form6Example2" className="form-control"  disabled value="20"/>
            </div>
          </div>
        </div>

        {/* <!-- Text input --> */}
        <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form6Example3">Transaction Hash ID (Ethereum/BSC )</label>
          <input type="text" id="form6Example3" className="form-control" value={hashid}
          onChange={(e) => setHashId(e.target.value)} />
        </div>
 
        {/* <!-- Submit button --> */}
        <div className="text-center">
            <button type="submit" className="btn btn-primary btn-block mb-4">Place order</button>
        </div>
           
    </div>
</div> 
    </form>
</div>


    
        </>
      )
}

export default EsproPay;